/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Select_Job_FirstInputs */

const en_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const de_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const fr_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const es_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const it_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const nl_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const pl_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const fi_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const da_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

const sv_story_bank_select_job_first = /** @type {(inputs: Story_Bank_Select_Job_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job first`)
};

/**
* | output |
* | --- |
* | "Select a job first" |
*
* @param {Story_Bank_Select_Job_FirstInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_select_job_first = /** @type {((inputs?: Story_Bank_Select_Job_FirstInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Select_Job_FirstInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_select_job_first(inputs)
	if (locale === "fr") return fr_story_bank_select_job_first(inputs)
	if (locale === "es") return es_story_bank_select_job_first(inputs)
	if (locale === "it") return it_story_bank_select_job_first(inputs)
	if (locale === "nl") return nl_story_bank_select_job_first(inputs)
	if (locale === "pl") return pl_story_bank_select_job_first(inputs)
	if (locale === "fi") return fi_story_bank_select_job_first(inputs)
	if (locale === "da") return da_story_bank_select_job_first(inputs)
	if (locale === "sv") return sv_story_bank_select_job_first(inputs)
	return en_story_bank_select_job_first(inputs)
});